import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, withStyles } from 'material-ui';

const styles = () => ({
  container: {
    width: '40%',
    margin: '0 auto',
  },
  title: {
    fontSize: '16px',
    marginBottom: '10px',
  },
  subheading: {
    color: '#8c8c8c',
    fontWeight: '300',
    marginBottom: '10px',
  },
});

const PaymentSubmission = ({ classes, initialValues }) => (
  <div className='step'>
    <Grid container spacing={16} className={classes.container}>
      <Grid item xs={12}>
        <Typography align='center' className={classes.title}>
          Thank you!
        </Typography>
        <Typography align='center' className={classes.subheading}>
          Please check your email for payment confirmation.
        </Typography>
        {initialValues.investmentStatus === 'PENDING_WALLET_ADDRESS' ? (
          <Typography align='center' className={classes.subheading}>
            <i>* You still need to enter your wallet address</i>
          </Typography>
        ) : null}
        {initialValues.investmentStatus === 'PENDING_TRANSACTION_RECEIPT' ? (
          <Typography align='center' className={classes.subheading}>
            <i>* You still need to upload your transaction receipt</i>
          </Typography>
        ) : null}
      </Grid>
    </Grid>
  </div>
);

PaymentSubmission.propTypes = {
  classes: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default withStyles(styles)(PaymentSubmission);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/PaymentSubmission.js